import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'
//////////////////////////////////////////
// DELCARE TO USE
/////////////////////////////////////////
Vue.use(Vuex)

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  strict: true
})



// WEBPACK FOOTER //
// ./src/model/store/index.js